import React, {Component} from 'react';
import moment from "moment/moment";
import 'moment/locale/tr';

import Select from"../../local_node_modules/react-select"
import '../../local_node_modules/react-select/dist/react-select.css';

import Datetime from "react-datetime/DateTime";
import 'react-datetime/css/react-datetime.css';
import {DatePicker} from "antd";


class SearchField extends Component {
	constructor(props) {
		super(props);

		this.state = {
			label: undefined,
			accessor: undefined,
			operator: undefined,
			type: undefined,
			value:'',
			selectData: []
		};

		this.createComponent = this.createComponent.bind(this);
		this.dateComponent = this.dateComponent.bind(this);
		this.dateTimeComponent = this.dateTimeComponent.bind(this);
		this.selectComponent = this.selectComponent.bind(this);
		this.textComponent = this.textComponent.bind(this);
		this.numericTextComponent = this.numericTextComponent.bind(this);
		this.dateComponent = this.dateComponent.bind(this);

		this.onChangeText = this.onChangeText.bind(this);
		this.onChangeNumericText = this.onChangeNumericText.bind(this);
		this.onChangeDate = this.onChangeDate.bind(this);
		this.onChangeSelect = this.onChangeSelect.bind(this);

	}

	dateComponent() {
		let dateValue = this.state.value ? moment(this.state.value,"YYYY-MM-DD") : null;
		return(
			<DatePicker
				value={dateValue}
				className="datepicker"
				placeholder="Tarih seçiniz."
				format= "DD-MM-YYYY"
				isClearable={true}
				isSearchable={true}
				style={{ width: 160 }}
				onChange={(date, dateString)=>this.onChangeDate(dateString,"date",this.props.accessor)}
			/>
		);
	}

	dateTimeComponent() {
		let dateValue = this.state.value ? moment(this.state.value,"YYYY-MM-DD") : null;

		return(
			<DatePicker
				value={dateValue}
				className="datepicker"
				placeholder="Tarih seçiniz."
				format= "DD-MM-YYYY"
				isClearable={true}
				isSearchable={true}
				style={{ width: "100%" }}
				onChange={(date,dateString)=>this.onChangeDate(dateString,"datetime",this.props.accessor)}
			/>
		);
	}



	localDateTimeComponent() {
		let dateValue = this.state.value;
		return (
			<Datetime locale="tr"
					  className="datepicker"
					  input={true}
					  closeOnSelect={true}
					  value={moment(dateValue, "YYYY-MM-DD HH:mm:ss", true).isValid() ? moment(dateValue).format("DD-MM-YYYY") : dateValue}
					  dateFormat="DD-MM-YYYY"
					  timeFormat="HH:mm:ss"
					  onChange={(e) => this.onChangeDate(e, "localdatetime", this.props.accessor)}/>

		)
	}

	monthComponent() {
		let dateValue = this.state.value;
		return (
			<Datetime locale="tr"
					  className="datepicker"
					  input={true}
					  closeOnSelect={true}
					  value={moment(dateValue, "YYYY-MM-DD HH:mm:ss", true).isValid() ? moment(dateValue).format("YYYY/MM") : dateValue}
					  dateFormat="MM/YYYY"
					  timeFormat={false}
					  onChange={(e) => this.onChangeDate(e, "month", this.props.accessor)}/>
		)
	}

	selectComponent() {
		return (
			<Select
				value={this.state.value}
				clearable={false}
				noResultsText="Veri yok"
				clearValueText="Temizle"
				placeholder="Seçiniz..."
				onChange={(e) => this.onChangeSelect(e, this.props.accessor)}
				options={this.props.selectData}
			/>
		)
	}

	textComponent(handleKeyPress) {
		return (
			<input className="form-control"
				   type="text"
				   onKeyPress={handleKeyPress}
				   value={this.state.value}
				   onChange={(e) => this.onChangeText(e, this.props.accessor)}/>
		)
	}

	numericTextComponent(handleKeyPress) {
		return (
			<input className="form-control"
				   type="text"
				   pattern="[0-9]*"
				   value={this.state.value}
				   onKeyPress={handleKeyPress}
				   onInput={(e) => this.onChangeNumericText(e, this.props.accessor)}/>
		)
	}

	/********** EVENT HANDLERS ****/

	onChangeSelect(e, fieldName) {

		if (!e) return

		this.setState({value: e.value})

		this.props.listener(fieldName, e.value)

	}

	onChangeText(e, fieldName) {

		if (!e) return;

		this.setState({value: e.target.value})

		this.props.listener(fieldName, e.target.value)

	}

	onChangeNumericText(e, fieldName) {

		if (!e) return;
		if (!e.target.validity.valid) {
			return;
		}

		let value = e.target.value;

		this.setState({value: value})

		this.props.listener(fieldName, value)

	}

	onChangeDate(momentObj, type, fieldValue) {
		let value;
		if (!(typeof momentObj === "string")) {
			if (type === "date") {
				value = momentObj.format("DD-MM-YYYY");
				this.setState({value});
			} else if (type === "datetime") {
				value = momentObj.format("DD-MM-YYYY 00:00:00");
				this.setState({value})
			} else if (type === "localdatetime") {
				value = momentObj.format("YYYY-MM-DD HH:mm:ss");
				this.setState({value})
			} else if (type === "month") {
				value = momentObj.format("YYYY-MM-DD HH:mm:ss");
				this.setState({value});
			}
		} else {
			value = momentObj;
			if(type=== "datetime" && moment(value,"DD-MM-YYYY",true).isValid()){
				value = moment(value,"DD-MM-YYYY",true).format("YYYY-MM-DDT00:00:00");
				//value = (momentObj !== null) ? moment(momentObj, "DD-MM-YYYY 00:00:00") : null;
			}
			if(type=== "date" && moment(value,"DD-MM-YYYY",true).isValid()){
				console.log("valid-----------------");
				value = moment(value,"DD-MM-YYYY",true).format("YYYY-MM-DD");
				//value = (momentObj !== null) ? moment(momentObj, "DD-MM-YYYY") : null;
			}
			this.setState({value})
		}

		this.props.listener(fieldValue, value)
	}


	render() {

		return (

			<div className="col-sm-6 row">
				<div className="col-sm-5" style={{marginBottom:'5px', marginLeft:'-5px'}}>
					{
						this.props.label
					}
				</div>

				<div className="col-sm-7" style={{marginBottom:'5px'}}>

					{
						this.props.type &&
						this.createComponent(this.props.type, this.props.operator)
					}
				</div>
			</div>

		)
	}


	/**** COMPONENT HANDLER ***/


	createComponent(type, operator) {
		if (type === "select") {
			return this.selectComponent();
		} else if (type === "date") {
			return this.dateComponent();
		} else if (type === "datetime") {
			return this.dateTimeComponent();
		} else if (type === "localdatetime") {
			return this.localDateTimeComponent();
		} else if (type === "month") {
			return this.monthComponent();
		} else if (type === "text") {
			return this.textComponent(this.props.onKeyPress);
		} else if (type === "numericText") {
			return this.numericTextComponent(this.props.onKeyPress);
		} else {
			return null;
		}
	}


}


export default SearchField;



// WEBPACK FOOTER //
// ./src/components/DetailedSearch/SearchField.js